module.exports = __webpack_public_path__ + "static/media/facebook-berichten-creatief.85120523.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/facebook-berichten-creatief.png
// module id = 190
// module chunks = 0